import axios from "axios";
import store from "@/store";
import router from "@/router";
import {toast} from '../class/Notification'
import {getNowString} from '../Modules/Timing'
import {queryBuilder} from "../class/QueryFilter";

export var order_status = [
    'منتظر پرداخت',
    'در حال پردازش',
    'تایید شده',
    'ارسال شده',
    'تحویل داده شده',
    'مرجوع شده',
    'لغو شده',
]

// generate random hash for product
export var generateHash = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export const findHashProductOnLocalStorage = (subProduct) => {
    let products = JSON.parse(localStorage.getItem('products'));
    let result = undefined
    for (let i in products) {
        let product = products[i]; // localstorage
        // subProduct => came from method

        if (product.variation == 0 && subProduct.id == product.id) {
            result = product.productHash
        }

        if (product.variation == 1 && subProduct.product_id == product.id && product.sub_product_id == subProduct.id) {
            result = product.productHash
        }

    }
    return result

}


export default {
    namespaced: true,
    state: {
        items: [],
        orders: [],
        userOrderUnpaidItems: [],
        userOrderPaidItems: [],
        sidebarBasketData: {},
        links: {},
        meta: {},
        productList: [],
        deliveryPrice: 0,
        deliveryBoundary: 0,
        freeCities: [],
        payDescript: [],
        filters: {
            search: '',
            status: '',
            multiple_store: ''
        },
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        addItem(state, item) {
            item.count = 1;
            state.items.push(item);
            state.userOrderUnpaidItems.push(item);
        },
        setOrders(state, orders) {
            state.orders = orders;
        },
        setUserOrderUnpaidItems(state, items) {
            state.userOrderUnpaidItems = items;
        },
        setUserOrderPaidItems(state, items) {
            state.userOrderPaidItems = items;
        },
        setSidebarBasketData(state, response) {
            state.sidebarBasketData = response;
        },
        removeItem(state, list) {
            state.userOrderUnpaidItems = list;
        },
        removeAll(state) {
            state.items.splice(0, state.items.lenght);
        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setProductList(state, productList) {
            state.productList = productList;
        },
        setDeliveryPrice(state, price) {
            state.deliveryPrice = price;
        },
        setDeliveryBoundary(state, boundary) {
            state.deliveryBoundary = boundary;
        },
        setFreeCities(state, cities) {
            state.freeCities = cities;
        },
        setpayDescript(state, description) {
            state.payDescript = description;
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        addItem({commit}, item) {
            const userId = store.getters["User/getUserId"];


            const res = axios.post(`/user/${userId}/order`, item);

            res.then((res) => {
                toast("محصول با موفقیت به سبد اضافه شد", "محصول با موفقیت به سبد اضافه شد");
                let response = res.data.data;
                commit("addItem", response);
                commit("setSidebarBasketData", response);
                commit("setUserOrderUnpaidItems", response.items);
            })
                .catch((error) => {
                    console.log(error);
                });

            return res
        },
        async addUnAuthItem({commit}, {product, sub_product}) {
            if (localStorage.getItem('products') === null) { // when first time user want add something to shopping Cart
                localStorage.setItem('products', "{}");
            }
            let products = JSON.parse(localStorage.getItem('products'));

            let checkIfProductWasExists = false;
            let itemQuantity = 0;
            let quantity = 0;
            let productHash = '';


            if (product.variation == 1) {
                quantity = sub_product.quantity;
                for (let i in products) {
                    const item = products[i];
                    if (item.id == product.id && item.sub_product_id == sub_product.id) {
                        checkIfProductWasExists = true;
                        itemQuantity = item.quantity;
                        productHash = i;
                    }
                }
            } else {
                quantity = product.quantity;
                for (let i in products) {
                    const item = products[i];
                    if (item.id == product.id) {
                        checkIfProductWasExists = true;
                        itemQuantity = item.quantity;
                        productHash = i;
                    }
                }
            }

            if (product.variation == 0 && quantity == null) {
                quantity = Infinity;
            }

            const quantityChecker = quantity - (itemQuantity + 1);


            if (quantityChecker >= 0) {
                if (checkIfProductWasExists) { // increase number of product if it exist

                    products[productHash] = {
                        "id": product.id,
                        "variation": product.variation,
                        "product": product.raw_link,
                        "price": product.price,
                        "discount": product.offer,
                        "productHash": productHash,
                        "sub_product_id": sub_product != undefined ? sub_product.id : null,
                        "quantity": products[productHash]['quantity'] + 1
                    };
                    toast("تعداد محصول با موفقیت به روز شد", "تعداد محصول با موفقیت به روز شد");
                    localStorage.setItem('products', JSON.stringify(products));
                    return true
                } else { // add product if not exist

                    const form = {
                        selected_date_time: getNowString(),
                        timable_type: 'product',
                        timable_id: product.id,
                    }

                    await store.dispatch('Timing/checkTiming', form).then(res => {
                        const status = res.data.data.status;
                        if (status) {
                            let newProductHash = generateHash();
                            products[newProductHash] = {
                                "id": product.id,
                                "variation": product.variation,
                                "product": product.raw_link,
                                "price": product.price,
                                "discount": product.offer,
                                "productHash": newProductHash,
                                "sub_product_id": sub_product != undefined ? sub_product.id : null,
                                "quantity": 1
                            };
                            toast("محصول با موفقیت به سبد اضافه شد", "محصول با موفقیت به سبد اضافه شد");
                            localStorage.setItem('products', JSON.stringify(products));
                            return true
                        } else {
                            toast("زمان خرید محصول به پایان رسیده است", "زمان خرید محصول به پایان رسیده است", 'danger');
                            return false
                        }

                    })


                }
            } else {
                toast("حداکثر تعداد موجودی در سبد شما قرار دارد", "حداکثر تعداد موجودی در سبد شما قرار دارد", 'danger');
                return false
            }
        },
        getOrders({commit}, page = 1) {
            const userId = store.getters["User/getUserId"];
            let req = axios.get(`/order/user/${userId}?page=${page}`)

            req.then((res) => {
                let response = res.data.data;
                commit("setOrders", response.data);
                commit("setLinks", response.links);
                commit("setMeta", response.meta);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        getUserOrdersWithoutState({commit}, form) {
            let req = axios.get(`/order/user/${form.user_id}?page=${form.page}`)
            return req
        },
        userOrderUnpaid({commit}) {
            if (router.currentRoute.name !== 'verifyTransaction') {
                return new Promise((resolve, reject) => {
                    const userId = store.getters["User/getUserId"];
                    axios
                        .get(`/unpayed/user/${userId}/order`)
                        .then((res) => {
                            let data = res.data.data;
                            let response = data.data;
                            if (response != undefined) {
                                const deliveryBoundary = data.delivery_free_boundary;
                                const delivery_price = response.delivery_amount;
                                const freeCities = data.free_cities_delivery;
                                const payDescript = data.description_on_payment_page[0].value;
                                commit("setUserOrderUnpaidItems", response.items);
                                commit("setSidebarBasketData", response);
                                commit("setDeliveryPrice", delivery_price);
                                commit("setDeliveryBoundary", deliveryBoundary);
                                commit("setFreeCities", freeCities);
                                commit("setpayDescript", payDescript);
                            }
                            resolve(response);
                        })
                        .catch((error) => {
                            console.log(error);
                            reject(error);
                        });
                });
            }
        },
        removeItem({commit}, form) {
            const user_id = store.getters["User/getUserId"];
            axios
                .delete(`/user/${user_id}/order/${form.order_id}`, {
                    data: {order_product_id: form.order_product_id},
                })
                .then((res) => {
                    let response = res.data.data;
                    commit("removeItem", response.items);
                    commit("setSidebarBasketData", response);
                    commit("setDeliveryPrice", response.delivery_amount);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateItem({commit}, form) {
            const user_id = store.getters["User/getUserId"];
            axios
                .put(`/user/${user_id}/order/${form.basket_id}`, {
                    order_product_id: form.order_product_id,
                    quantity: form.quantity,
                })
                .then((res) => {
                    let response = res.data.data;
                    commit("setSidebarBasketData", response);
                    commit("setUserOrderUnpaidItems", response.items);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        chooseAddressAndDescription({commit}, form) {
            const user_id = store.getters["User/getUserId"];
            return axios
                .put(
                    `/user/${user_id}/order/${form.order}/set-address-and-description`,
                    {
                        address_id: form.address_id,
                        description: form.description,
                    }
                )
                .then((res) => {
                    let response = res.data.data;
                    commit("setSidebarBasketData", response);
                    commit("setUserOrderUnpaidItems", response.items);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAllOrders({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/order?page=${page}&${query}`);

            req.then((res) => {
                let response = res.data.data;
                commit("setOrders", response.data);
                commit("setLinks", response.links);
                commit("setMeta", response.meta);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        getAllOrdersWithOrderItems({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/order/with-order-items?page=${page}&${query}`)

            req.then((res) => {
                let response = res.data.data;
                commit("setOrders", response.data);
                commit("setLinks", response.links);
                commit("setMeta", response.meta);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        removeAll({commit}) {
            commit("removeAll");
        },
        changeOrderStatus({commit}, {order_id, status}) {
            axios.put(`order/order/${order_id}/update-order-status`, {status: status})
                .then((res) => {
                    let response = res.data.data;
                    toast('.عملیات با موفقیت انجام شد', 'تغییر وضعیت سفارش با موفقیت انجام شد.', 'success')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProductList({commit, state}, productsLinkArray) {
            state.productList = []
            productsLinkArray.forEach(link => {
                axios
                    .get(`product/${link}`)
                    .then((response) => {
                        response = response.data.data;
                        state.productList.push(response)
                    })
                    .catch((error) => {
                        localStorage.removeItem('products')
                    });
            })
        },
        async getProductListWithoutState({commit, state}, productsLinkArray) {
            try {
                let productList = await Promise.all(productsLinkArray.map(async (link) => {
                    let response = await axios.get(`product/${link}`);
                    return response.data.data;
                }));
                return productList;
            } catch (error) {
                localStorage.removeItem('products');
                throw error; // Re-throw the error to be caught by the caller if necessary
            }
        },
        getUserUnPaidOrderWithoutState({commit}, userId) {
            return axios.get(`/unpayed/user/${userId}/order`)
        },
        changeQuantityWithoutState({commit}, form) {
            return axios.put(`/user/${form.user_id}/order/${form.order_id}`, form)
        },
        addItemWithoutState({commit}, {user_id, form}) {
            return axios.post(`/user/${user_id}/order`, form)
        },
        getDeliveryPrice({commit}, form) {
            return axios.post(`calculate-delivery-price`, form)
        },
        updateOrderGeneralInfo({commit}, form) {
            axios
                .post(`order/update/${form.order_id}/general-info`, form)
                .then((res) => {
                    toast('.عملیات با موفقیت انجام شد', '.عملیات با موفقیت انجام شد', 'success')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    getters: {
        getItems: (state) => {
            return state.items;
        },
        getItemById: (state) => (id) => {
            return state.items.find((itm) => itm.id == id);
        },
        getOrders: (state) => state.orders,
        getUserOrderUnpaidItems: (state) => state.userOrderUnpaidItems,
        getUserOrderPaidItems: (state) => state.userOrderPaidItems,
        getSidebarBasketData: (state) => state.sidebarBasketData,
        getPaginationLinks: (state) => state.links,
        getPaginationMeta: (state) => state.meta,
        getProductList: (state) => state.productList,
        getDeliveryPrice: (state) => state.deliveryPrice,
        getDeliveryBoundary: (state) => state.deliveryBoundary,
        getFreeCities: (state) => state.freeCities,
        getPayDescript: (state) => state.payDescript,
        getFilters: (state) => state.filters,
    },
};
